import React from 'react';
import { createIconElement } from '@/lib';
import IconHeading from '@/assets/icons/ic-heading-square.svg';
import IconBold from '@/assets/icons/ic-bold.svg';
import IconItalic from '@/assets/icons/ic-italic.svg';
import IconStrike from '@/assets/icons/ic-strike-through.svg';
import IconList from '@/assets/icons/ic-bulleted-list.svg';
import IconLink from '@/assets/icons/ic-link.svg';
import IconAiGenerate from '@/assets/icons/ic-ai-generate-01.svg';
import IconEdit from '@/assets/icons/ic-edit-01.svg';
import styles from './Toolbar/StanTipTapEditorToolbar.module.css';

// Lazy icon creation to avoid module initialization issues
let _bareHeadingIcon: React.ReactNode;
let _bareBoldIcon: React.ReactNode;
let _bareItalicIcon: React.ReactNode;
let _bareStrikeIcon: React.ReactNode;
let _bareListIcon: React.ReactNode;
let _bareLinkIcon: React.ReactNode;
let _bareAiGenerateIcon: React.ReactNode;
let _bareEditIcon: React.ReactNode;

export const BareHeadingIcon = () => {
    if (!_bareHeadingIcon) {
        _bareHeadingIcon = createIconElement(IconHeading, { className: styles.toolbarButtonIcon });
    }
    return _bareHeadingIcon;
};

export const BareBoldIcon = () => {
    if (!_bareBoldIcon) {
        _bareBoldIcon = createIconElement(IconBold, { className: styles.toolbarButtonIcon });
    }
    return _bareBoldIcon;
};

export const BareItalicIcon = () => {
    if (!_bareItalicIcon) {
        _bareItalicIcon = createIconElement(IconItalic, { className: styles.toolbarButtonIcon });
    }
    return _bareItalicIcon;
};

export const BareStrikeIcon = () => {
    if (!_bareStrikeIcon) {
        _bareStrikeIcon = createIconElement(IconStrike, { className: styles.toolbarButtonIcon });
    }
    return _bareStrikeIcon;
};

export const BareListIcon = () => {
    if (!_bareListIcon) {
        _bareListIcon = createIconElement(IconList, { className: styles.toolbarButtonIcon });
    }
    return _bareListIcon;
};

export const BareLinkIcon = () => {
    if (!_bareLinkIcon) {
        _bareLinkIcon = createIconElement(IconLink, { className: styles.toolbarButtonIcon });
    }
    return _bareLinkIcon;
};

export const BareAiGenerateIcon = () => {
    if (!_bareAiGenerateIcon) {
        _bareAiGenerateIcon = createIconElement(IconAiGenerate, { className: styles.toolbarButtonIcon });
    }
    return _bareAiGenerateIcon;
};

export const BareEditIcon = () => {
    if (!_bareEditIcon) {
        _bareEditIcon = createIconElement(IconEdit, { className: styles.toolbarButtonIcon });
    }
    return _bareEditIcon;
};
